import { useStateValue } from "../../context/StateValueContext";
import { HasPermission } from "../../functions/auth";
import { PERMISSIONS } from "../../constants/permissions";
import { useCompanyId } from "../../hooks/useCompanyId";
import { companySearchText } from "../../utils/companyUtils";
import SearchableHeaderDropdown from "./SearchableHeaderDropdown";

export default function CompanySelector() {
  const [{ miniCompanies }] = useStateValue();
  const { companyId: selectedCompanyId, setCompanyId } = useCompanyId();

  if (miniCompanies.length === 0) {
    return null;
  }

  const options = miniCompanies.map((company) => ({
    id: company.id,
    label: company.name,
    searchText: companySearchText(company),
  }));

  return (
    <HasPermission permission={PERMISSIONS.DISPUTES_ALL_COMPANIES}>
      <SearchableHeaderDropdown
        options={options}
        selectedId={selectedCompanyId}
        onSelect={setCompanyId}
        allLabel="All Companies"
        searchPlaceholder="Search companies..."
        emptyMessage="No companies found"
        widthClass="w-[320px]"
        icon={
          <svg
            className="w-4 h-4 flex-shrink-0 text-gray-500 dark:text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
            />
          </svg>
        }
      />
    </HasPermission>
  );
}
